import * as ScoreType from '../../../../../../constants/ScoreType';
import { Map } from 'immutable';
function normalize(score) {
    if (!score) {
        return 0;
    }
    if (score === 100) {
        return 'A';
    }
    return score;
}
export function getTennisScores(scores) {
    var defaultScore = new Map({ score1: 0, score2: 0 });
    var matchScores = (scores.filter(function (score) { return score.get('type') == ScoreType.Match; }).first() || defaultScore).toJS();
    var currentGameScore = (scores.filter(function (score) { return score.get('type') == ScoreType.CurrentGame; }).first() || defaultScore).toJS();
    return {
        firstTeamTotal: matchScores.score1,
        secondTeamTotal: matchScores.score2,
        firstTeamCurrentGame: normalize(currentGameScore.score1),
        secondTeamCurrentGame: normalize(currentGameScore.score2),
        isFirstTeamServe: currentGameScore.team === 1,
        isSecondTeamServe: currentGameScore.team === 2
    };
}



// WEBPACK FOOTER //
// ./src/components/grid/common/sportsGrid/statistics/mainScores/tennis.js